import { api } from '../api/client';
import { createRecoveryPackage, type CreateRecoveryPackageResult } from './recovery';

export async function createAndPublishRecoveryPackage(
  userId: string,
  vaultKey: Uint8Array,
): Promise<CreateRecoveryPackageResult> {
  const vaultStatus = await api.getVaultStatus();
  const created = await createRecoveryPackage(
    userId,
    vaultKey,
    vaultStatus.recoveryActive,
    vaultStatus.recoveryGeneration,
  );

  await api.putRecoveryPackage({
    recoveryPublicKey: created.recoveryPublicKey,
    recoveryVkWrap: created.recoveryVkWrap,
    recoveryGeneration: created.recoveryGeneration,
  });

  return created;
}
